<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 75vh;">
                <ejs-grid ref='gridms' :dataSource="shapeData" :allowFiltering='true' :allowPaging="true" :allowResizing='true'
                          :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete'
                          :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar'
                          :pageSettings='pageSettings' :actionBegin='actionBegin' :actionComplete='actionComplete' 
                          :actionFailure="actionFailure" :filterSettings='filterOptions' :queryCellInfo='customiseCell' width="100%" height="100%">
                    <e-columns>
                        <e-column field='marketShapeId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='name' headerText='Name' :validationRules="nameRules" width=120></e-column>
                        <e-column field='period' headerText='Period Indicator' :validationRules="requiredRules" textAlign='Right' foreignKeyField="periodId" foreignKeyValue='name' :dataSource='periods' editType='dropdownedit' :edit='periodIndicatorParams' width=90></e-column>
                        <e-column field='periodName' headerText='Period Indicator' textAlign='Right' :visible="false" width=90></e-column>
                        <e-column field='periodSpan' headerText='Period' textAlign='Right' :validationRules="requiredRules" foreignKeyField="periodSpanId" foreignKeyValue='name' :dataSource='periodSpans' editType='dropdownedit' :edit='periodParams' width=90></e-column>
                        <e-column field='periodSpanName' headerText='Period' textAlign='Right' :visible="false" width=90></e-column>
                        <e-column field='percentage' headerText='Percentage' textAlign='Right' :validationRules="percentageRules" format="n4" editType='numericedit' :edit='numericParams' width=90></e-column>
                        <e-column field='year' headerText='Year' textAlign='Right' :validationRules='yearRules' editType='numericedit' :edit='yearParams' width=90></e-column>
                        <e-column field='ricId' headerText='Identifier' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='ricParams' foreignKeyField="id" foreignKeyValue='fullRic' :dataSource='rics' width=90></e-column>
                        <e-column field='ricName' headerText='Identifier' textAlign='Right' :visible="false" width=90></e-column>
                        <e-column field='stateName' headerText='Country' textAlign='Right' :allowEditing="false" width=90></e-column>
                        <e-column field='pricingAreaName' headerText='Price Area' textAlign='Right' :allowEditing="false" width=90></e-column>
                        <e-column field='utilityTypeName' headerText='Commodity' textAlign='Right' :allowEditing="false" width=90></e-column>
                        <e-column field='product' headerText='Product' textAlign='Right' :allowEditing="false" width=90></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :uploading="addHeaders" :allowedExtensions="extensions" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createElement } from '@syncfusion/ej2-base';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DataManager, WebApiAdaptor, ODataV4Adaptor } from "@syncfusion/ej2-data";
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import authToken from '../../../common/authToken';
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import urls from '../../../common/urls'
    import apis from '../../../common/network'
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';

    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let rics = SyncHelper.getDataManager('Utils/rics');
    let periods = SyncHelper.getDataManager('Utils/shapePeriods');
    let periodSpans = SyncHelper.getDataManager('Utils/periodSpans');
    let months = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];

    let periodIndicatorElem, periodParamElem, periodIndicatorObj, periodSpanObj, ricObj, ricElem;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                rics: rics,
                periodSpans: periodSpans,
                periods: periods,
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                yearParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "####"
                    }
                },
                path: {
                    saveUrl: `${urls.apiBaseUrl}MarketShape/Import/`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                shapeData: SyncHelper.getDataManager("MarketShape"),
                //ricParams: {
                //  params: {
                //    allowFiltering: true,
                //    dataSource: rics,
                //    fields: { text: "core", value: "id" },

                //    query: new Query(),
                //    actionComplete: () => false
                //  }
                //},

                ricParams: {
                    create: () => {
                        ricElem = document.createElement('input');
                        return ricElem;
                    },
                    read: () => {
                        return ricObj.value;
                    },
                    destroy: () => {
                        ricObj.destroy();
                    },
                    write: (args) => {
                        ricObj = new DropDownList({
                            dataSource: rics,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            change: (args) => {
                                apis.protectedApi(`${urls.apiBaseUrl}Utils/rics`).then(it => {
                                    var mappedRic = it.data.filter(function (ric) {
                                        return ric.id == args.value;
                                    });
                                    document.getElementsByName("product")[0].value = mappedRic[0].product;
                                    document.getElementsByName("utilityTypeName")[0].value = mappedRic[0].utilityTypeName;
                                    document.getElementsByName("stateName")[0].value = mappedRic[0].stateName;
                                    document.getElementsByName("pricingAreaName")[0].value = mappedRic[0].pricingAreaName;

                                }
                                ).catch(
                                    response => {
                                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                        gridOptions.errorAlert("Error: " + message);
                                    }
                                );
                                //args.itemData.product = "P";
                            },
                            placeholder: 'Identifier',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        ricObj.appendTo(ricElem);
                    }
                },
                periodIndicatorParams: {
                    create: () => {
                        periodIndicatorElem = document.createElement('input');
                        return periodIndicatorElem;
                    },
                    read: () => {
                        return periodIndicatorObj.value;
                    },
                    destroy: () => {
                        periodIndicatorObj.destroy();
                    },
                    write: (args) => {
                        periodIndicatorObj = new DropDownList({
                            dataSource: periods,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            change: () => {
                                periodSpanObj.enabled = true;
                                let tempQuery = new Query().where('periodId', 'equal', periodIndicatorObj.value);
                                periodSpanObj.query = tempQuery;
                                periodSpanObj.text = null;
                                periodSpanObj.dataBind();
                            },
                            placeholder: 'Period Indicator',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });

                        periodIndicatorObj.appendTo(periodIndicatorElem);
                        // periodIndicatorElem.value = args.rowData.periodIndicator;
                    }
                },
                periodParams: {
                    create: () => {
                        periodParamElem = document.createElement('input');
                        return periodParamElem;
                    },
                    read: () => {
                        return periodSpanObj.value;
                    },
                    destroy: () => {
                        periodSpanObj.destroy();
                    },
                    write: function (args) {
                        periodSpanObj = new DropDownList({
                            dataSource: periodSpans,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            enabled: (args.foreignKeyData ? true : false),
                            placeholder: 'Period',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                            actionComplete: function (e) {
                                if (periodIndicatorObj.text == 'Month') {
                                    if (e.result.length > 0) {
                                        e.result.sort(function (a, b) {
                                            return months.indexOf(a.name) - months.indexOf(b.name);
                                        });
                                    }
                                } 
                            },
                            query: new Query().where('periodId', 'equal', periodIndicatorObj.value)

                        });
                        periodSpanObj.appendTo(periodParamElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.MarketShape.Update"],
                    allowAdding: store.state.permissions["Permissions.MarketShape.Create"],
                    allowDeleting: store.state.permissions["Permissions.MarketShape.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                percentageRules: { required: true, number: true, maxLength: [(args) => { return args['value'] <= 999; }, 'Please enter a value lower than 999'] },
                requiredRules: { required: true },
                nameRules: { required: true, maxLength: 50 },
                yearRules: { required: true, minLength: [(args) => { return args['value'].length == 4; }, 'Need 4 digits'] },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.gridms.getColumns()[2].visible = false;
                    this.$refs.gridms.getColumns()[3].visible = true;
                    this.$refs.gridms.getColumns()[4].visible = false;
                    this.$refs.gridms.getColumns()[5].visible = true;
                    this.$refs.gridms.getColumns()[8].visible = false;
                    this.$refs.gridms.getColumns()[9].visible = true;
                    this.$refs.gridms.getColumns()[0].visible = true; // add id column
                }
                gridOptions.excelExport(args, "Market Shape.xlsx", this.$refs);

            },
            excelExportComplete(args) {
                this.$refs.gridms.hideSpinner();
                this.$refs.gridms.getColumns()[2].visible = true;
                this.$refs.gridms.getColumns()[3].visible = false;
                this.$refs.gridms.getColumns()[4].visible = true;
                this.$refs.gridms.getColumns()[5].visible = false;
                this.$refs.gridms.getColumns()[8].visible = true;
                this.$refs.gridms.getColumns()[9].visible = false;
                this.$refs.gridms.getColumns()[0].visible = false;

            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridms.getColumns().length; i++) {

                    }
                }
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));


                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if (args.requestType === "beginEdit") {
                    args.form[5].value = args.form[5].value + "%";  //add %sign here in the form

                    args.form[5].addEventListener("focusout", e => {
                        if (e.target.classList.contains("e-numerictextbox")) {
                            e.target.value = e.target.value + "%";
                        }
                    });
                }

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["name","percentage","year"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.gridms.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.gridms.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            customiseCell: function (args) {
                if (args.column.field === 'percentage') {
                    args.cell.textContent = args.cell.textContent + "%";
                }
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
    .e-textbox[id$="stateName"],
    .e-textbox[id$="pricingAreaName"],
    .e-textbox[id$="utilityTypeName"],
    .e-textbox[id$="product"] {
        text-align: Left !important;
    }
</style>
